const s = {
  name: "SslCertificate",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15.3,28c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C14.7,26.8,15.3,27.3,15.3,28z"/>
		<path class="st0" d="M7,34h14V22h-3v-1c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4v1H7V34z M19,24v8H9v-8H19z M16,21v1h-4v-1
			c0-1.1,0.9-2,2-2S16,19.9,16,21z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h13.4L28,11.6V37c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M3,2C2.5,2,2,2.5,2,3v34
			c0,0.5,0.5,1,1,1h22c0.5,0,1-0.5,1-1V14h-8.8c-1.8,0-3.2-1.4-3.2-3.2V2H3z M16,2.4v8.4c0,0.6,0.5,1.2,1.2,1.2h8.4L16,2.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as SslCertificate
};
